/* eslint-disable  */
import { getPaginationFromMeta } from '../utils/commonFunctions';

export const GET_MY_STORES_LIST_REP_PENDING = 'GET_MY_STORES_LIST_REP_PENDING';
export const GET_MY_STORES_LIST_REP_REJECTED = 'GET_MY_STORES_LIST_REP_REJECTED';
export const GET_MY_STORES_LIST_REP_FULFILLED = 'GET_MY_STORES_LIST_REP_FULFILLED';
export const GET_SCANNING_DISABLED_OUTLETS_PENDING = 'GET_SCANNING_DISABLED_OUTLETS_PENDING';
export const GET_SCANNING_DISABLED_OUTLETS_FULFILLED = 'GET_SCANNING_DISABLED_OUTLETS_FULFILLED';
export const GET_SCANNING_DISABLED_OUTLETS_REJECTED = 'GET_SCANNING_DISABLED_OUTLETS_REJECTED';
export const REENABLE_SCANNING_PENDING = 'REENABLE_SCANNING_PENDING';
export const REENABLE_SCANNING_FULFILLED = 'REENABLE_SCANNING_FULFILLED';
export const REENABLE_SCANNING_REJECTED = 'REENABLE_SCANNING_REJECTED';

const initialState = {
  performances: {
    stock_it: [],
    sell_it: []
  },
  stores: [],
  repOutlets: [],
  repPaging: {
    number: 1,
    size: 20,
  },
  paging: {
    number: 1,
    size: 20,
  },
  fetching: false,
  fetched: false,
  errors: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_STORE_PERFORMANCE_DATA_PENDING':
    case GET_MY_STORES_LIST_REP_PENDING:
    case 'GET_OUTLETS_PENDING':
    case GET_SCANNING_DISABLED_OUTLETS_PENDING:
    case REENABLE_SCANNING_PENDING: {
      return { ...state, fetching: true, fetched: false };
    }
    case GET_MY_STORES_LIST_REP_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        repOutlets: action.payLoad.data,
        repPaging: getPaginationFromMeta(initialState.repPaging, state.repPaging, action.payLoad.links),
      }
    }
    case GET_SCANNING_DISABLED_OUTLETS_FULFILLED:
    case REENABLE_SCANNING_FULFILLED: 
    case 'GET_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stores: action.payLoad.data
      };
    }
    case 'GET_ADMIN_OUTLETS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        stores: action.payLoad.data,
        links: action.payLoad.links,
        paging: getPaginationFromMeta(initialState.paging, state.paging, action.payLoad.links),
      };
    }
    case GET_SCANNING_DISABLED_OUTLETS_REJECTED:
    case 'GET_OUTLETS_REJECTED':
    case REENABLE_SCANNING_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payLoad
      }
    }
    case 'GET_STORE_PERFORMANCE_DATA_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        performances: action.payLoad,
      };
    }
    default:
  }

  return {...state};
}
